/* script */
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

const __vue_script__ = {
    name: 'ExternalPickerDetails',

    props: {
        doc: {
            type: [Object, String],
            required: true
        },

        eventId: {
            type: String,
            required: true
        },

        fpType: {
            type: String,
            required: true
        },

        emitKey: {
            type: String,
            required: true
        },

        sortable: {
            type: Boolean,
            default: false
        },

        options: {
            type: Array,
            default: () => []
        },

        disabled: {
            type: Boolean,
            default: false
        },

        timezone: {
            type: String,
            default: undefined
        },

        locale: {
            type: String,
            default: 'en'
        }
    },

    computed: {
        /**
         * Generates a URL for the given document.
         *
         * @returns {string} The URL of the document.
         */
        itemsLink() {
            const context = typeof this.doc === 'string' ? { _id: this.doc } : this.doc;
            if (!context.hasOwnProperty('_id')) {
                context._id = this.doc.value || this.doc[this.emitKey];
            }

            return this.$services.blueprint.getFpTypeViewPath(this.eventId, this.fpType, context);
        }
    },

    methods: {
        /**
         * Given a document this method returns the proper label
         *
         * @param {object|string} item the document or its label
         *
         * @returns {string} the item label
         */
        getItemLabel(item) {
            return this.$utils.locales.getExtPickerDocLabel(item, this.emitKey, { ...this.options, locale: this.locale });
        },

        /**
         * Retrieves the date and time information from the given item.
         *
         * @param {Object} item - The item from which to extract the date and time.
         * @returns {Object} An object containing the date and time information.
         */
        getItemDateAndTime(item) {
            return this.$utils.time.convertTimestampToHumanForm(item.timestamp, this.timezone);
        },
    }
};

/* template */
var __vue_render__ = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "ext-picker-details" },
    [
      _c("div", { staticClass: "details" }, [
        _vm.sortable
          ? _c("i", { staticClass: "ic-menu drag", attrs: { tabindex: "0" } })
          : _vm._e(),
        _c("i", {
          staticClass: "type",
          class: _vm.$utils.assets.getIconForType(_vm.fpType),
        }),
        _vm.doc.timestamp
          ? _c("span", { staticClass: "badge" }, [
              _vm._v(_vm._s(_vm.getItemDateAndTime(_vm.doc))),
            ])
          : _vm._e(),
        _vm.doc.badge
          ? _c("span", { staticClass: "badge", class: _vm.doc.badge_classes }, [
              _vm._v(_vm._s(_vm.doc.badge)),
            ])
          : _vm._e(),
        _c(
          "div",
          { staticClass: "option" },
          [
            _vm.itemsLink
              ? _c(
                  "a",
                  { staticClass: "title", attrs: { href: _vm.itemsLink } },
                  [_vm._v(_vm._s(_vm.getItemLabel(_vm.doc)))]
                )
              : _c("div", { staticClass: "title" }, [
                  _vm._v(_vm._s(_vm.getItemLabel(_vm.doc))),
                ]),
            _vm._t("document-item-subtitle", null, { doc: _vm.doc }),
          ],
          2
        ),
      ]),
      _vm._t("document", null, { doc: _vm.doc }),
      _c(
        "div",
        { staticClass: "actions" },
        [
          _vm._t("doc-actions", null, { doc: _vm.doc }),
          _c(
            "a",
            {
              staticClass: "remove has-action",
              class: { disabled: _vm.disabled },
              attrs: { href: "#" },
              on: {
                click: function ($event) {
                  return _vm.$emit("remove")
                },
              },
            },
            [_c("i", { staticClass: "ic-x" })]
          ),
        ],
        2
      ),
    ],
    2
  )
}
var __vue_staticRenderFns__ = []
__vue_render__._withStripped = true

  /* style */
  const __vue_inject_styles__ = undefined
  /* scoped */
  const __vue_scope_id__ = undefined
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "apps/shared/src/ui/components/form-components/pickers/ExternalPickerDetails.vue"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (false) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  )

  export default __vue_component__